import React, {Component} from 'react';

class ChangePassword extends Component{
    render(){
        return(
            <div className="edit-caregiver">
            <div className="container">
                <div className="row">
                    <div className="col-sm-8">
                    <form>
                        <div className="edit-div">
                            <h4>Change password</h4>
                            <div className="row">
                                <div className="col-sm-6 offset-sm-3">
                                    <label>
                                        Current password
                                        <input type="password"/>
                                    </label>
                                    <label>
                                        New password
                                        <input type="password"/>
                                    </label>
                                    <label>
                                        Confirm new password
                                        <input type="password"/>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="edit-div buttons">
                            <div className="button-div">
                                <button className="cancel-btn">Cancel</button>
                                <button type="submit">Save Changes</button>
                            </div>
                        </div>
                    </form>
                    </div>
                </div>
            </div>
            </div>
        )
    }
}

export default ChangePassword;



// WEBPACK FOOTER //
// ./src/components/ChangePassword.js